module.exports = __webpack_public_path__ + "img/Patrick.46ee7a94.png";